<template>
  <div id="app">
    <NHBRHeader />
    <Nav />
    <router-view />
  </div>
</template>

<script>
import NHBRHeader from "@/components/Header.vue"
import Nav from "@/components/Nav.vue"

export default {
  name: "App",
  components: {
    NHBRHeader,
    Nav
  }
}
</script>


<style lang="scss">
body {
  margin: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  .nhbr-recommended, .nhbr-recommended input {
    border-color: #dca235;
    box-shadow: 0 0 0 0.2rem rgba(220, 162, 53, 0.25);
  }

  .nhbr-invalid, .nhbr-invalid input {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }

  h1 {
    text-align: left;
    margin-top: 32px;
    margin-bottom: 32px;
    padding-left: 24px;
    padding-right: 24px;
  }


  .card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: transparent;
    border-bottom: none;
  }

  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: white;
    background-color: #dd763c;
    font-weight: bold;
    border-radius: 5px 5px 0 0;
    border: none;
    border-bottom: 1px solid #dd763c;
  }

  .nav-tabs .nav-link {
    background: #f4f4f4;
    margin-left: 4px;
    margin-right: 4px;
    color: #363636;
    border: 1px solid transparent;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
}

.tooltip-inner {
  max-width: 100% !important;
  text-align: initial !important;
  margin: 0px !important;
}

.column-flex-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.row-flex-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

i.icon.cancel:before, i.icon.close:before, i.icon.delete:before, i.icon.x:before {
  content: "\f00d";
  font-style: normal;
  font-family: FontAwesome;
}

i.icon:before {
  background: none!important;
}

</style>
